export const fireMiraklImpression = products => {
  if (!products) return
  const adId = products?.collection
    ?.filter(it => it.adId)
    ?.map(it => it.adId)
    ?.join('|')
  fireEvent('impression', { adId })
  // eslint-disable-next-line no-console
  console.log('Mirakl impression for adId:', adId)
}

export const fireMiraklClick = adId => {
  if (!adId) return
  fireEvent('click', { adId })
  // eslint-disable-next-line no-console
  console.log('Mirakl clicked for adId:', adId)
}

const fireEvent = (eventType, data) => {
  if (window?.miraklTag) return window?.miraklTag?.event(eventType, data)
  // mirakl js may load lately, so we postpone the event a bit
  setTimeout(() => window?.miraklTag?.event(eventType, data), 3000)
}
